import './App.css';
import './index.css';

export function GraphingPorfolio() {
  return (
    <>
      <div className="portfolio md:mb-6 lg:mb-6">
        <h1 className='title'>Graphing Portfolio</h1>
      </div>
      <h1 className='heading'>Off-Street Parking Occupancy (Parking Lots)</h1>
      <div className="offstreet text-2xl grid lg:grid-cols-2 md:grid-cols-1">
        <div>
          <p>A councilmember reached out to me asking our firm to study whether off-street parking is overutilized. He said that his constituents believe that there is not enough space to park in New Brunswick.</p>
          <p>
            Our firm conducted a study to see whether there was sufficient parking in New Brunswick. We used Google Maps to determine the parking utilization in New Brunswick in certain parking lots, and conducted in-person studies. 
          </p>
          <p>
            We determined that on street parking is fairly abundant for New Brunswick on George Street, likely because there’s a huge parking garage just down the street, which greatly reduces the need for on-street parking.
          </p>
          <p>
            Our recommendation was that the parking requirements shouldn’t be changed because parking is underutilized across the board in New Brunswick.
          </p>
        </div>
        <div>
          <img src='https://irosenb-portfolio.s3.us-west-2.amazonaws.com/percentage.png' alt="" />
          <img src='https://irosenb-portfolio.s3.us-west-2.amazonaws.com/average-occupancy.png' alt="" />
        </div>
      </div>
      <h1 className='heading'>Transit Delay</h1>
      <div className="delay text-2xl grid lg:grid-cols-2 md:grid-cols-1">
        <div>
          <p>
            In this assignment, we were asked to conduct a study of transit delay for a bus line. The City Council has been receiving numerous complaints from riders that they are experiencing delay. Could this be the case? We had to find out by riding the bus ourselves.
          </p>
          <p>
            I conducted my analysis by riding Route 818 on New Jersey Transit. Armed with my iPhone, I tracked every moment that the bus experienced any kind of delay, whether it stopped to pick up a passenger or waited at a signal. 
          </p>
          <p>
            For the first graph, during off-peak hours, the bus was moving very smoothly. There was minimal congestion. 
          </p>
          <p>
            For the second graph, my analysis of class-wide data showed that there is slightly more delay for buses in peak hours. 
          </p>
          <p>
            My recommendation for the City Council in New Brunswick would be to install bus-only lanes during peak hours to ensure a smooth experience for riders.
          </p>
        </div>
        <div>
          <img src='https://irosenb-portfolio.s3.us-west-2.amazonaws.com/delay.png' alt="Transit delay" />
          <img src='https://irosenb-portfolio.s3.us-west-2.amazonaws.com/share-delay.png' alt="" />
        </div>
      </div>
      <h1 className='heading'>On-Street Parking Occupancy</h1>
      <div className="onstreet text-2xl grid lg:grid-cols-2 md:grid-cols-1">
        <div>
          <p>
            In this assignment, I was asked to conduct a study of on-street parking in my area. According to one City Councilmember, they have been receiving complaints at local meetings that parking is vastly undersupplied at all hours of the day and night. Is this true? Only one way to find out: go out into the field and see for myself. 
          </p>
          <p>
            I conducted my data collection on George Street in New Brunswick, NJ, just steps from the renowned Bloustein School. I did my study three times during the evening: 5:45pm, 7:13pm, and 8:05pm.
          </p>
          <p>
            What I found was simple: there was plenty of parking in the evening for everyone that wanted an on-street parking spot. Parking at the worst time, 5:45pm, was under 60% occupied. That is well below Shoup’s target occupancy of 85%.
          </p>
          <p>
            This was true for the classwide data: parking occupancy was above 80% only 25 percent of the time in the evenings.
          </p>
          <p>
            For my particular block, I don’t see a need to increase parking prices or need for performance parking as there’s a huge parking garage just down the street. However, there is need to do the study at an earlier time of the day to see what parking occupancy is like then.
          </p>
          <p>
            My recommendation to the City Council would be that there is no need to change curbside parking rules.
          </p>
        </div>
        <div>
          <img src='https://irosenb-portfolio.s3.us-west-2.amazonaws.com/parking.png' alt="" />
          <img src='https://irosenb-portfolio.s3.us-west-2.amazonaws.com/parking-percent.png' alt="" />
        </div>
      </div>
    </>
  );
}
